// extracted by mini-css-extract-plugin
module.exports = {"breakMobile":"768","breakMedium":"992","breakLarge":"1280","breakXL":"1440","breakXSHeight":"600"};